import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appSelectors } from '@lialo/core/lib/pages/app';
import { commonActions, commonSelectors } from '@lialo/core/lib/pages/common';
import ErrorPage from '../Page/ErrorPage/ErrorPage';
import { useTranslation } from 'react-i18next';
import { errorTranslationKey } from '@lialo/core/lib/translations/translationHelper';
import { LoadingScreen } from '@lialo/pwa-ui/lib/PageComponents/Loading';
import { To } from '@lialo/core/lib/services';

interface IProps {
  parentUrl: To;
  children: React.ReactNode;
}

export const RequireUser = (props: IProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(commonSelectors.selectUser);
  const error = useSelector(appSelectors.selectError);

  const signInAnonymously = () => dispatch(commonActions.signInAnonymously());

  useEffect(() => {
    if (!user) {
      signInAnonymously();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (user) {
    return <>{props.children}</>;
  } else if (error) {
    return <ErrorPage message={t(errorTranslationKey(error))} parentUrl={props.parentUrl} retry={signInAnonymously} />;
  } else {
    return <LoadingScreen />;
  }
};
